import { ActivityCriteria, CriteriaConfig, LogFilterType } from '../../../dtos/search-criteria.dto';
import { ActivityActionsSorted, getEnumOptions, TimeRange } from '../../../utils/enums';
import { useStores } from '../../store';
import { checkSingleIp } from '../../../utils/ipValidationUtil';

export const useActivityCriteriaConfig = (): CriteriaConfig<ActivityCriteria>[] => {
    const { activityStore } = useStores();
    return [
        {
            accessor: 'timeDetails',
            header: 'Time',
            type: LogFilterType.TIME,
            defaultValue: TimeRange.LAST_7_DAYS,
            options: [TimeRange.TODAY,
                TimeRange.YESTERDAY,
                TimeRange.LAST_24_HOURS,
                TimeRange.LAST_7_DAYS].map((value) => ({ value, label: value })),
            width: 300
        },
        {
            accessor: 'activity',
            header: 'Activity',
            type: LogFilterType.MULTISELECT,
            defaultValue: '',
            options: getEnumOptions(ActivityActionsSorted),
            width: 180
        },
        {
            accessor: 'policyVersion',
            header: 'Policy Version',
            type: LogFilterType.MULTISELECT,
            defaultValue: '',
            options: activityStore.filters.policyVersions?.slice()?.sort((a: any, b: any) => {
                return a > b ? 1 : -1;
            }).map((_: number) =>
                    ({ value: `${_}`, label: `V${_}` })),
            width: 180,
            showSearch: true
        },
        {
            accessor: 'user',
            header: 'User',
            type: LogFilterType.INPUT,
            defaultValue: '',
            width: 180
        },
        {
            accessor: 'clientIp',
            header: 'Client IP',
            type: LogFilterType.INPUT,
            defaultValue: '',
            width: 140,
            validationRules: [checkSingleIp]
        }
    ];
};

